/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Location_HintInputs */

const en_case_field_location_hint = /** @type {(inputs: Case_Field_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highway + km / address.`)
};

const pt_br2_case_field_location_hint = /** @type {(inputs: Case_Field_Location_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodovia + km / endereço.`)
};

/**
* | output |
* | --- |
* | "Highway + km / address." |
*
* @param {Case_Field_Location_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_location_hint = /** @type {((inputs?: Case_Field_Location_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Location_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_location_hint(inputs)
	return pt_br2_case_field_location_hint(inputs)
});